/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, {Component} from 'react'; // eslint-disable-line no-unused-vars

import Lists from './Lists';

/**
 * ListsContainer
 */
export default class ListsContainer extends Component {
    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }

    render() { // eslint-disable-line
        return (
            <Lists {...this.props} />
        );
    }
}
